const BuyerInventoryCorrectionTabKeys = {
  SUBMITTED: "SUBMITTED",
  REVIEW: "REVIEW"
} as const;

type BuyerInventoryCorrectionTabKey = typeof BuyerInventoryCorrectionTabKeys[keyof typeof BuyerInventoryCorrectionTabKeys];

const BuyerInventoryCorrectionTabs: Record<BuyerInventoryCorrectionTabKey, string> = {
  [BuyerInventoryCorrectionTabKeys.SUBMITTED]: 'Submitted Corrections',
  [BuyerInventoryCorrectionTabKeys.REVIEW]: 'Review & Correct',
};

const formatTabHeader = (label: any, count: number | string) => {
  return count ? `${label} (${count})` : label;
}

export type {BuyerInventoryCorrectionTabKey};
export {BuyerInventoryCorrectionTabKeys, BuyerInventoryCorrectionTabs, formatTabHeader};
